// extracted by mini-css-extract-plugin
export default {"CandidateSourceTag":"styles_CandidateSourceTag__7oAIp"};